import { ReactComponent as ThinnectLogo } from './../assets/icons/Thinnect_white.svg';
import footerMobilePicture from '../assets/img/footer_login_mobile.png';
import footerMediumPicture from '../assets/img/footer_login_medium.png';
import footerLargePicture from '../assets/img/footer_login_large.png';
import { useAppSelector } from '../redux/hooks';

const appVersion = process.env.REACT_APP_VERSION;
const supportURL = process.env.REACT_APP_SUPPORT_URL;

const MainFooter = () => {
	const isLoggedIn = useAppSelector((state) => state.authentication.loggedIn);

	return isLoggedIn ? (
		<footer className="mt-auto">
			<small className="my-5 d-flex flex-column align-items-center">
				<a
					className="d-flex flex-column flex-sm-row align-items-center text-decoration-none text-reset focus-ring"
					target="_blank"
					rel="noopener noreferrer"
					href="https://thinnect.com"
				>
					<span className="me-0 me-sm-2">Solution provided by:</span>
					<ThinnectLogo style={{ width: '125px', fill: 'currentColor' }} />
				</a>
				<div className="d-flex flex-row align-items-center justify-content-center gap-1 mt-1">
					{appVersion ? <div>Version: {appVersion}</div> : undefined}
					{appVersion && supportURL && <div>|</div>}
					{supportURL && (
						<a
							href={supportURL}
							target="_blank"
							rel="noopener noreferrer"
							className="link-primary link-underline-opacity-50 link-underline-opacity-100-hover focus-ring"
						>
							Support
						</a>
					)}
				</div>
			</small>
		</footer>
	) : (
		<footer>
			<picture>
				<source media="(min-width:1200px)" srcSet={footerMediumPicture} />
				<source media="(min-width:576px)" srcSet={footerLargePicture} />
				<img
					src={footerMobilePicture}
					alt="Mobile login footer"
					className="w-100 h-auto opacity-75"
				/>
			</picture>
		</footer>
	);
};

export default MainFooter;
